import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthUser } from "../../contexts/AuthUserContext";
import { API_BASE } from "../../utils/api/api";

const BusinessDomainPage = () => {
  const [businessDomainUrl, setBusinessDomainUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { user, signIn } = useAuthUser();
  const navigate = useNavigate();

  const handleContinue = async () => {
    setError("");
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE}/api/users/onboarding/domain`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify({ businessDomainUrl }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to save domain");

      signIn({ onboarding: data.onboarding });
      navigate(data.nextRoute || "/", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 1.25rem",
        background: "var(--bg-app)",
      }}
    >
      <div
        style={{
          width: "min(480px, 100%)",
          background: "var(--bg-sb)",
          border: "1px solid var(--bd)",
          borderRadius: 24,
          padding: "2.5rem 2rem",
          boxShadow: "var(--app-shadow)",
        }}
      >
        <h2 style={{ margin: "0 0 0.25rem", fontSize: 22, fontWeight: 700, color: "var(--tp)" }}>
          What is your business domain?
        </h2>
        <p style={{ margin: "0 0 1.75rem", fontSize: 14, color: "var(--ts2)" }}>
          Enter your store or website URL so Zeqi can connect your data
        </p>
        <input
          type="url"
          placeholder="https://yourstore.com"
          value={businessDomainUrl}
          onChange={(e) => setBusinessDomainUrl(e.target.value)}
          style={{
            width: "100%",
            padding: "0.75rem 0.9rem",
            borderRadius: 12,
            border: "1px solid var(--input-border)",
            background: "var(--input-bg)",
            color: "var(--tp)",
            fontSize: 14,
            boxSizing: "border-box",
            marginBottom: "1rem",
          }}
        />
        {error && (
          <p style={{ fontSize: 13, color: "var(--danger-text)", marginBottom: "0.75rem" }}>{error}</p>
        )}
        <button
          onClick={handleContinue}
          disabled={loading || !businessDomainUrl.trim()}
          style={{
            width: "100%",
            padding: "0.875rem",
            borderRadius: 999,
            border: "none",
            background: "var(--ac)",
            color: "var(--hero-contrast)",
            fontSize: 15,
            fontWeight: 700,
            cursor: businessDomainUrl.trim() ? "pointer" : "not-allowed",
            opacity: !businessDomainUrl.trim() ? 0.55 : 1,
          }}
        >
          {loading ? "Saving…" : "Continue"}
        </button>
      </div>
    </div>
  );
};

export default BusinessDomainPage;
